import { renderFilterSet } from "./js/filters"

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-section='filter-container']")
    .forEach(renderFilterSet)
})
